<form [formGroup]="approvalflowForm" class="f-col blank-form">
    <div class="section-heading">
        <h2>{{content?.['b2b.manageapproval.approvalflowsettings']}}</h2>
    </div>

    <div class="section-content">
        <div class="inner-contentsection">
            <div class="f-row">
                <div class="f-col">
                    <div class="f-row validation-col">
                        <label class="mat-label">{{content?.['b2b.manageapproval.approvalflow']}}</label>
                        <mat-radio-group aria-label="Select an option" formControlName="approvalFlow">
                            <mat-radio-button
                                value="EIT">{{content?.['b2b.manageapproval.parallel']}}</mat-radio-button>
                            <mat-radio-button
                                value="SEQ">{{content?.['b2b.manageapproval.sequential']}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
            <div class="f-row">
                <div class="f-col">
                    <mat-form-field>
                        <mat-label>{{content?.['b2b.manageapproval.totalapprovers']}}</mat-label>
                        <mat-icon fontSet="material-symbols-outlined" matSuffix
                            class="mat-select">stat_minus_1</mat-icon>
                        <mat-select formControlName="totalApprovals"
                            (selectionChange)="onApproverCountChange($event.value)">
                            <mat-option *ngFor="let count of approverCounts" [value]="count"> {{ count }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- In Policy Approvers -->
        <div class="inner-contentsection">
            <h4 class="subheading">{{content?.['b2b.manageapproval.inpolicy']}}</h4>
            <div class="f-row two--ColLayout">
                <div class="f-col" *ngIf="selectedApproverCount >= 1">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>{{content?.['b2b.manageapproval.level1']}}</mat-label>
                        <input matInput type="text" [formControl]="inPolicyApproverIDL1SearchControl"
                            [matAutocomplete]="inPolicyAuto1" autocomplete="off" data-control-name="inPolicyApproverIDL1"
                            (input)="inpolicyInputList($event)" (focus)="clearCorporateUsers()" (keypress)="blockInvalidCharacters($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="inPolicyApproverIDL1SearchControl.value"
                            (click)="clearApprover('inPolicyApproverIDL1', inPolicyApproverIDL1SearchControl, $event)" aria-label="Clear approver">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #inPolicyAuto1="matAutocomplete"
                            (optionSelected)="onApproverSelected('inPolicyApproverIDL1', inPolicyApproverIDL1SearchControl, $event)">
                            <mat-option *ngIf="CorporateUsers.length === 0" [disabled]="true">
                                {{noItemFound || 'No matching approver found.'}}
                            </mat-option>
                            <mat-option *ngFor="let user of CorporateUsers" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.title ? user.title + ' ' : ''}}{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.manageapproval.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error class="px-4"
                            *ngIf="approvalflowForm.get('inPolicyApproverIDL1')?.hasError('required') && approvalflowForm.get('inPolicyApproverIDL1')?.touched">
                            {{dictionaryContent?.['b2b.manageapproval.approverfieldreq'] || 'Approver field is required.'}} </mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col" *ngIf="selectedApproverCount >= 2">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>{{content?.['b2b.manageapproval.level2']}}</mat-label>
                        <input matInput type="text" [formControl]="inPolicyApproverIDL2SearchControl"
                            [matAutocomplete]="inPolicyAuto2" autocomplete="off" data-control-name="inPolicyApproverIDL2"
                            (input)="inpolicyInputList($event)" (focus)="clearCorporateUsers()" (keypress)="blockInvalidCharacters($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="inPolicyApproverIDL2SearchControl.value"
                            (click)="clearApprover('inPolicyApproverIDL2', inPolicyApproverIDL2SearchControl, $event)" aria-label="Clear approver">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #inPolicyAuto2="matAutocomplete"
                            (optionSelected)="onApproverSelected('inPolicyApproverIDL2', inPolicyApproverIDL2SearchControl, $event)">
                            <mat-option *ngIf="CorporateUsers.length === 0" [disabled]="true">
                                {{noItemFound || 'No matching approver found.'}}
                            </mat-option>
                            <mat-option *ngFor="let user of CorporateUsers" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.title ? user.title + ' ' : ''}}{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.manageapproval.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error class="px-4"
                            *ngIf="approvalflowForm.get('inPolicyApproverIDL2')?.hasError('required') && approvalflowForm.get('inPolicyApproverIDL2')?.touched">
                            {{content?.['b2b.manageapproval.approverfieldreq'] || 'Approver field is required.'}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="f-col" *ngIf="selectedApproverCount >= 3">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>{{content?.['b2b.manageapproval.level3']}}</mat-label>
                        <input matInput type="text" [formControl]="inPolicyApproverIDL3SearchControl"
                            [matAutocomplete]="inPolicyAuto3" autocomplete="off" data-control-name="inPolicyApproverIDL3"
                            (input)="inpolicyInputList($event)" (focus)="clearCorporateUsers()" (keypress)="blockInvalidCharacters($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="inPolicyApproverIDL3SearchControl.value"
                            (click)="clearApprover('inPolicyApproverIDL3', inPolicyApproverIDL3SearchControl, $event)" aria-label="Clear approver">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #inPolicyAuto3="matAutocomplete"
                            (optionSelected)="onApproverSelected('inPolicyApproverIDL3', inPolicyApproverIDL3SearchControl, $event)">
                            <mat-option *ngIf="CorporateUsers.length === 0" [disabled]="true">
                                {{noItemFound || 'No matching approver found.'}}
                            </mat-option>
                            <mat-option *ngFor="let user of CorporateUsers" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.title ? user.title + ' ' : ''}}{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.manageapproval.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error class="px-4"
                            *ngIf="approvalflowForm.get('inPolicyApproverIDL3')?.hasError('required') && approvalflowForm.get('inPolicyApproverIDL3')?.touched">
                            {{dictionaryContent?.['b2b.manageapproval.approverfieldreq'] || 'Approver field is required.'}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Out of Policy Approvers -->
        <div class="inner-contentsection">
            <h4 class="subheading">{{content?.['b2b.manageapproval.outofpolicy']}}</h4>
            <div class="f-row two--ColLayout">
                <div class="f-col" *ngIf="selectedApproverCount >= 1">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>{{content?.['b2b.manageapproval.level1']}}</mat-label>
                        <input matInput type="text" [formControl]="outPolicyApproverIDL1SearchControl"
                            [matAutocomplete]="outPolicyAuto1" autocomplete="off" data-control-name="outPolicyApproverIDL1"
                            (input)="inpolicyInputList($event)" (focus)="clearCorporateUsers()" (keypress)="blockInvalidCharacters($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="outPolicyApproverIDL1SearchControl.value"
                            (click)="clearApprover('outPolicyApproverIDL1', outPolicyApproverIDL1SearchControl, $event)" aria-label="Clear approver">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #outPolicyAuto1="matAutocomplete"
                            (optionSelected)="onApproverSelected('outPolicyApproverIDL1', outPolicyApproverIDL1SearchControl, $event)">
                            <mat-option *ngIf="CorporateUsers.length === 0" [disabled]="true">
                                {{noItemFound || 'No matching approver found.'}}
                            </mat-option>
                            <mat-option *ngFor="let user of CorporateUsers" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.title ? user.title + ' ' : ''}}{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.manageapproval.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error class="px-4"
                            *ngIf="approvalflowForm.get('outPolicyApproverIDL1')?.hasError('required') && approvalflowForm.get('outPolicyApproverIDL1')?.touched">
                            {{content?.['b2b.manageapproval.approverfieldreq'] || 'Approver field is required.'}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="f-col" *ngIf="selectedApproverCount >= 2">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>{{content?.['b2b.manageapproval.level2']}}</mat-label>
                        <input matInput type="text" [formControl]="outPolicyApproverIDL2SearchControl"
                            [matAutocomplete]="outPolicyAuto2" autocomplete="off" data-control-name="outPolicyApproverIDL2"
                            (input)="inpolicyInputList($event)" (focus)="clearCorporateUsers()" (keypress)="blockInvalidCharacters($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="outPolicyApproverIDL2SearchControl.value"
                            (click)="clearApprover('outPolicyApproverIDL2', outPolicyApproverIDL2SearchControl, $event)" aria-label="Clear approver">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #outPolicyAuto2="matAutocomplete"
                            (optionSelected)="onApproverSelected('outPolicyApproverIDL2', outPolicyApproverIDL2SearchControl, $event)">
                            <mat-option *ngIf="CorporateUsers.length === 0" [disabled]="true">
                                {{noItemFound || 'No matching approver found.'}}
                            </mat-option>
                            <mat-option *ngFor="let user of CorporateUsers" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.title ? user.title + ' ' : ''}}{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.manageapproval.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error class="px-4"
                            *ngIf="approvalflowForm.get('outPolicyApproverIDL2')?.hasError('required') && approvalflowForm.get('outPolicyApproverIDL2')?.touched">
                            {{dictionaryContent?.['b2b.manageapproval.approverfieldreq'] || 'Approver field is required.'}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="f-col" *ngIf="selectedApproverCount >= 3">
                    <mat-form-field appearance="fill" data-dd-privacy="mask">
                        <mat-label>{{content?.['b2b.manageapproval.level3']}}</mat-label>
                        <input matInput type="text" [formControl]="outPolicyApprover_DL3SearchControl"
                            [matAutocomplete]="outPolicyAuto3" autocomplete="off" data-control-name="outPolicyApprover_DL3"
                            (input)="inpolicyInputList($event)" (focus)="clearCorporateUsers()" (keypress)="blockInvalidCharacters($event)"
                            (paste)="onPasteBlocked($event)" (contextmenu)="disableRightClick($event)" />
                        <button mat-icon-button matSuffix type="button" tabindex="-1"
                            *ngIf="outPolicyApprover_DL3SearchControl.value"
                            (click)="clearApprover('outPolicyApprover_DL3', outPolicyApprover_DL3SearchControl, $event)" aria-label="Clear approver">
                            <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
                        </button>
                        <mat-autocomplete #outPolicyAuto3="matAutocomplete"
                            (optionSelected)="onApproverSelected('outPolicyApprover_DL3', outPolicyApprover_DL3SearchControl, $event)">
                            <mat-option *ngIf="CorporateUsers.length === 0" [disabled]="true">
                                {{noItemFound || 'No matching approver found.'}}
                            </mat-option>
                            <mat-option *ngFor="let user of CorporateUsers" [value]="user">
                                <div class="ng-select-user-checkbox">
                                    <span class="name-text">{{user.title ? user.title + ' ' : ''}}{{user.userName}}</span>
                                    <span class="email-text">{{user.emailAddress}}</span>
                                    <span class="email-text">{{content?.['b2b.manageapproval.employeeid'] || 'Employee ID'}} - {{user.employeeCode}}</span>
                                </div>
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error class="px-4"
                            *ngIf="approvalflowForm.get('outPolicyApprover_DL3')?.hasError('required') && approvalflowForm.get('outPolicyApprover_DL3')?.touched">
                            {{dictionaryContent?.['b2b.manageapproval.employeeid'] || 'Approver field is required.'}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="inner-action">
            <button mat-button class="button--secondary-small"
                (click)="onCancel()">{{content?.['b2b.manageapproval.cancel']}}</button>
            <button mat-button class="button--primary-small"
                [class.disabled]="approvalflowForm.invalid"
                [disabled]="approvalflowForm.invalid"
                (click)="onSave()">{{content?.['b2b.manageapproval.save']}}</button>
        </div>
    </div>
</form>